<div class="w-full flex flex-col gap-2">
  <ngx-form-factory
    [form]="form"
    [formFields]="fieldsService.registerFields"
    (keydown.enter)="onRegister()"
  />
  <div class="flex flex-row items-center justify-between w-full gap-4">
    <a [routerLink]="['/auth/login']">{{
      'auth.alreadyHaveAccount' | translate
    }}</a>
    <app-button
      [text]="'auth.register' | translate"
      (click)="onRegister()"
      size="small"
    ></app-button>
  </div>
</div>
